import React from 'react';
import { SearchSuggestionButtonProps } from './search-suggestion.button.props';
import './search-suggestion.component.css';

/*
 * Implementing a compound button react component.
 */
interface SearchSuggestionCompoundButtonProps extends SearchSuggestionButtonProps {
    readonly description: string;
    readonly fileTypeNarratorString?: string;
}

const boldStartingTag = '<b0>';
const boldEndingTag = '</b0>';
const boldStartingTagLength = boldStartingTag.length;
const boldEndingTagLength = boldEndingTag.length;

export class SearchSuggestionCompoundButtonComponent extends React.Component<SearchSuggestionCompoundButtonProps> {

    public readonly handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.currentTarget.blur();
        this.props.handleClick?.(e);
    }

    public readonly handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();
            this.props.handleClick(e);
        } else if (e.key === 'ArrowRight' && this.props.secondaryButtonProps) {
            e.preventDefault();
            e.currentTarget.blur();
            this.props.secondaryButtonProps.onClick(e);
        }
    }

    public readonly handleSubButtonClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        this.props.secondaryButtonProps.onClick(e);
    }

    public render() {
        const boldStartingIndex = this.props.title.indexOf(boldStartingTag);
        const boldEndingIndex = this.props.title.lastIndexOf(boldEndingTag);

        return (
            <div className={this.props.style !== undefined ? 'search-compound-button-container ' + this.props.style : 'search-compound-button-container'}  role='option' data-nav='true' tabIndex={-1} onKeyDown={e => this.handleKeyPress(e)}>
                <a className='search-compound-button-container__link' onClick={e => this.handleClick(e)} tabIndex={-1} target={this.props.target} >
                    {!this.props.hideIcon &&
                    <div className='search-icon'>
                        <div className='search-icon__container'>
                            { this.props.fileTypeNarratorString && <span className='Search-icon__container__offScreen'>{this.props.fileTypeNarratorString}</span> }
                            <div className={this.props.icon + ' search-icon--image'}></div>
                        </div>
                    </div>}
                    <div className={(this.props.isPwa && this.props.isDarkMode ? 'search-compound-button-container__text--darkMode' : 'search-compound-button-container__text') + (this.props.useThemeColor ? ' ms-fcl-tda' : '')}>
                        { boldStartingIndex >= 0 ?
                        <div className='search-buttons-title'>
                            <span>{this.props.title.substring(0, boldStartingIndex)}</span>
                            <strong>{this.props.title.substring(boldStartingIndex + boldStartingTagLength, boldEndingIndex)}</strong>
                            <span>{this.props.title.substring(boldEndingIndex + boldEndingTagLength)}</span>
                        </div> :
                        <div aria-label={this.props.title + '.'}>
                            <div className='search-buttons-title'>{this.props.title}</div>
                        </div>
                        }
                        <div className='search-compound-button-container__text__description'>{this.props.description}</div>
                    </div>
                </a>
                {this.props.secondaryButtonProps &&
                <div>
                    <span className='search-compound-button-wrapper'><span className={'search-compound-button-wrapper_divider ' + (this.props.isPwa && this.props.isDarkMode ? 'search-compound-button-wrapper_divider--darkMode' : 'search-compound-button-wrapper_divider--normal')}></span></span>
                    <div className={'search-subButton ' + (this.props.isPwa && this.props.isDarkMode ? 'search-subButton--darkMode' : 'search-subButton--normal')} tabIndex={-1} onClick={e => this.handleSubButtonClick(e)} aria-label={this.props.secondaryButtonProps.ariaLabel}>
                        <div>
                            <div className={this.props.secondaryButtonProps.icon + ' search-subButton__icon'}></div>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}
